import mapStore from '../storeInstances/mapStore';

export default class SelectMapTileStore {

  public tileLayers: ITileLayer[] = [
    { id: 'tiles-openStreetMap-layer', label: '街道' },
    { id: 'tiles-layer', label: '卫星' },
    { id: 'tiles-googleMap-layer',label:'谷歌'},
  ];

  public selectTile(id: string) {
    this.tileLayers.forEach(item => mapStore.setVisibility(item.id, item.id === id));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/SelectMapTileStore.ts